// utils/navigation.js

import { useNavigate } from "react-router-dom";

import { getLanguage } from "./getLanguage";

export const useNavigateWithLang = () => {
  const navigate = useNavigate();

  return (path, queryParams = {}, state = null) => {
    const lang = getLanguage();
    let url = `/${lang}${path}`;

    const queryString = new URLSearchParams(queryParams).toString();
    if (queryString) {
      url += `?${queryString}`;
    }

    navigate(url, { state });
  };
};
